module.exports = __webpack_public_path__ + "static/media/ic_stop.18cc7630.png";